<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>巡航路线详情</span>
          <div class="toolbar-items">
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="基本信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航编码" class="detail-form-item">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="类型" class="detail-form-item" prop="type">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                        <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="观察点名称" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.nodeId">
                        <el-option v-for="item in nodes" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="摄像机名称" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.cameraId">
                        <el-option v-for="item in cameras" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航间隔时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.stopTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="巡航单步时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.stepStopTime"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="开始巡航点" class="detail-form-item">
                      <el-input size="medium" v-model="entity.beginPoint"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="结束巡航点" class="detail-form-item">
                      <el-input size="medium" v-model="entity.endPoint"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="开始角度" class="detail-form-item">
                      <el-input size="medium" v-model="entity.beginAngle"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="结束角度" class="detail-form-item">
                      <el-input size="medium" v-model="entity.endAngle"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="单步角度" class="detail-form-item">
                      <el-input size="medium" v-model="entity.stepAngle"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" rows="5" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="巡航预置点列表">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-table :data="entity.cruisePoints" border style="width: 100%" @row-click="rowClick">
              <el-table-column prop="no" label="序号" width="50"> </el-table-column>
              <el-table-column prop="nodeDetail.code" label="观察目标编号" width="120"> </el-table-column>
              <el-table-column prop="nodeDetail.name" label="观察目标名称" width="200"> </el-table-column>
              <el-table-column prop="time" label="预置点编号" width="100"> </el-table-column>
              <el-table-column prop="name" label="预置点名称" width="300"> </el-table-column>              
              <el-table-column prop="horizontal" label="水平角" width="100"> </el-table-column>
              <el-table-column prop="vertical" label="俯仰角" width="100"> </el-table-column>
              <el-table-column prop="zoom" label="焦距" width="100"> </el-table-column>
              <el-table-column prop="callZoom" label="是否聚焦" width="100">
                <template #default="scope">
                  <div class="column-tag">
                    <el-tag v-if="scope.row.callZoom" type="danger" size="mini">是</el-tag>
                    <el-tag v-else size="mini">否</el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import {
  createCruiseContext,
  createNodeContext,
} from "@/script/apps/recon/config/ReconConfig";
import { Cruise, Node } from "@/script/apps/recon/entity/ReconEntity";
import { Camera } from "@/script/apps/device/entity/DeviceEntity";
import { createCameraContext } from "@/script/apps/device/config/DeviceConfig";

@Options({})
export default class CruiseDetail extends BaseDetail {
  nodes?: Node[] = [];
  cameras?: Camera[] = [];

  public initData(): ServiceContext {
    return createCruiseContext();
  }

  public newEntity() {
    const entity: Cruise = { node: { name: "" }, camera: { name: "" } };
    return entity;
  }

  protected initOptions() {
    super.initOptions();

    createNodeContext().service.loadFullList((data: Node[]) => {
      this.nodes = data;
    });
    createCameraContext().service.loadFullList((data: Camera[]) => {
      this.cameras = data;
    });
  }
}
</script>

<style lang="scss">
</style>
